export default {
    // neutrals
    'neutral-100': '#FFFFFF',
    'neutral-200': '#F6F6F6',
    'neutral-300': '#E8E8E8',
    'neutral-400': '#C6C6C6',
    'neutral-500': '#A0A0A0',
    'neutral-600': '#7F7F7F',
    'neutral-700': '#454545',
    'neutral-800': '#333333',
    'neutral-900': '#292929',
    'neutral-1000': '#000000',

    // greens
    'green-100': '#E3EBEC',
    'green-200': '#B1CCCF',
    'green-300': '#8BB3B8',
    'green-400': '#559097',
    'green-500': '#357A83',
    'green-600': '#025964',
    'green-700': '#02515B',
    'green-800': '#013F47',
    'green-900': '#013137',
    'green-1000': '#01252A',

    // gold
    'gold-100': '#F5EEE5',
    'gold-200': '#F4C991',
    'gold-300': '#D7903F',
    'gold-400': '#BF8038',
    'gold-500': '#B37835',
    'gold-600': '#8F602A',
    'gold-700': '#6C481F',
    'gold-800': '#543819',
    'gold-900': '#452B0E',
    'gold-1000': '#291A08',

    // blue
    'blue-100': '#E8EDF6',
    'blue-200': '#BACBEB',
    'blue-300': '#8EB0E1',
    'blue-400': '#5283CD',
    'blue-500': '#1B3CA3',
    'blue-600': '#163287',
    'blue-700': '#12296E',
    'blue-800': '#0E1F54',
    'blue-900': '#0B1B49',
    'blue-1000': '#0A173E',

    // systems
    'system-success': '#14CB8E',
    'on-system-success': '#FFFFFF',
    'system-error': '#CD3439',
    'system-warning': '#F77D03',

    // additional
    'secondary-hover': '#3BC175CC',
    'primary-hover': '#6C3987CC',
    'tertiary-hover': '#F5E7F5CC',
    'disabled-background': '#E7E7E7CC',
    'neutral-alpha-80': '#FFFFFFCC',
}